module.exports = __webpack_public_path__ + "assets/img/404.82d1d0e7.png";